import React from 'react';
import { useHistory } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import imgSend from '../../assets/images/1.png';
import imgBills from '../../assets/images/2.png';
import imgLoans from '../../assets/images/3.png';
import imgOffline from '../../assets/images/4.png';
import imgCard from '../../assets/images/5.png';
import imgRefer from '../../assets/images/6.png';

const ServicesSection = () => {
  const history = useHistory();
  const features = [
    {
      id: 'send',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2">
          <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" fill="#ff4400" fillOpacity="0.1" />
        </svg>
      ),
      title: 'Send & Receive Money Instantly',
      description: 'Transfer to any bank account or Waya user in seconds. Safe, seamless, and always instant.',
      size: 'large',
      image: imgSend,
    },
    {
      id: 'bills',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" fill="#ff4400" fillOpacity="0.1" />
          <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
        </svg>
      ),
      title: 'Pay Bills Anytime',
      description: 'From airtime to electricity. One app, all payments.',
      size: 'medium',
      image: imgBills,
    },
    {
      id: 'loans',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2" fill="#ff4400" fillOpacity="0.1" />
          <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" />
        </svg>
      ),
      title: 'Access Fast Loans',
      description: 'Apply for funds in minutes with low interest.',
      size: 'medium',
      image: imgLoans,
    },
    {
      id: 'offline',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" fill="#ff4400" fillOpacity="0.1" />
          <path d="M12 18h.01" />
        </svg>
      ),
      title: 'Works Without Internet',
      description: 'Dial our USSD code to bank anywhere.',
      size: 'small',
      image: imgOffline,
    },
    {
      id: 'card',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2">
          <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="#ff4400" fillOpacity="0.1" />
        </svg>
      ),
      title: 'ATM Cards',
      description: 'Spend globally with Waya cards.',
      size: 'small',
      image: imgCard,
    },
    {
      id: 'refer',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff4400" strokeWidth="2">
          <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" fill="#ff4400" fillOpacity="0.1" />
          <circle cx="8.5" cy="7" r="4" fill="#ff4400" fillOpacity="0.1" />
          <line x1="20" y1="8" x2="20" y2="14" />
          <line x1="23" y1="11" x2="17" y2="11" />
        </svg>
      ),
      title: 'Refer & Earn',
      description: 'Get rewarded for every friend you invite.',
      size: 'small',
      image: imgRefer,
    },
  ];

  return (
    <section className="services-bento-section">
      <div className="bg-glow" />

      <div className="container">
        <Fade bottom>
          <div className="section-header">
            <span className="eyebrow">OUR SERVICES</span>
            <h2 className="title">
              Banking that moves <span className="gradient-text">with you</span>
            </h2>
            <p className="subtitle">
              We've built a suite of tools designed to make your financial life simpler, faster, and more rewarding.
            </p>
          </div>
        </Fade>

        <div className="bento-grid">
          {features.map((feature, idx) => (
            <Fade bottom delay={idx * 100} key={feature.id}>
              <div
                className={`bento-card ${feature.size}`}
                onClick={() => {
                  if (feature.id === 'loans') {
                    history.push('/loans');
                  } else {
                    window.dispatchEvent(new CustomEvent('waya-open-download-popup'));
                  }
                }}
              >
                <div className="card-image-wrapper">
                  <img src={feature.image} alt="" className="card-image" />
                </div>
                <div className="card-content">
                  <div className="icon-box">
                    {feature.icon}
                  </div>
                  <div className="text-box">
                    <h3 className="card-title">{feature.title}</h3>
                    <p className="card-desc">{feature.description}</p>
                  </div>
                </div>
                <div className="card-bg-effect" />
              </div>
            </Fade>
          ))}
        </div>
      </div>

      <style>{`
        .services-bento-section {
          position: relative;
          padding: 120px 24px;
          background: #ffffff;
          overflow: hidden;
        }

        .bg-glow {
          position: absolute;
          top: 20%;
          left: 50%;
          width: 800px;
          height: 800px;
          background: radial-gradient(circle, rgba(255,68,0,0.03) 0%, rgba(255,68,0,0) 70%);
          transform: translate(-50%, -50%);
          pointer-events: none;
          z-index: 0;
        }

        .container {
          position: relative;
          max-width: 1280px;
          margin: 0 auto;
          z-index: 1;
        }

        .card-image-wrapper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          overflow: hidden;
          opacity: 0.5;
          transition: all 0.5s ease;
        }

        .card-image {
          width: 100%;
          height: 100%;
          object-fit: cover; /* Stretch edge-to-edge */
          transition: transform 0.7s ease;
          position: absolute;
          top: 0;
          left: 0;
        }

        .bento-card:hover .card-image-wrapper {
          opacity: 0.7;
        }

        .bento-card:hover .card-image {
          transform: scale(1.08);
        }

        .section-header {
          text-align: center;
          margin-bottom: 80px;
        }

        .eyebrow {
          color: #ff4400;
          font-size: 13px;
          font-weight: 800;
          letter-spacing: 4px;
          text-transform: uppercase;
          display: block;
          margin-bottom: 16px;
        }

        .title {
          font-size: clamp(36px, 5vw, 56px);
          font-weight: 900;
          color: #0f172a;
          margin-bottom: 24px;
          line-height: 1.1;
          letter-spacing: -0.05em;
        }

        .gradient-text {
          color: #ff4400;
        }

        .subtitle {
          max-width: 650px;
          margin: 0 auto;
          color: #64748b;
          font-size: 19px;
          line-height: 1.6;
        }

        /* ── Bento Grid ── */
        .bento-grid {
          display: grid;
          grid-template-columns: repeat(12, 1fr);
          grid-auto-rows: minmax(160px, auto);
          gap: 24px;
        }

        .bento-card {
          position: relative;
          background: #fdfdfd;
          border: 1px solid rgba(15,23,42,0.06);
          border-radius: 32px;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 40px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          cursor: pointer;
          height: 100%;
          z-index: 1;
        }

        .bento-card.large {
          grid-column: span 6;
          grid-row: span 2;
        }

        .bento-card.medium {
          grid-column: span 6;
          grid-row: span 1;
        }

        .bento-card.small {
          grid-column: span 4;
          grid-row: span 1;
        }

        .bento-card .card-content {
          justify-content: flex-end;
          align-items: flex-start;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .icon-box {
          width: 56px;
          height: 56px;
          min-width: 56px;
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ff4400;
          transition: all 0.3s ease;
          margin-bottom: auto; /* Push to top */
        }

        .bento-card:hover .icon-box {
          transform: scale(1.1);
        }

        .card-title {
          font-size: 22px;
          font-weight: 800;
          color: #000000; /* Pure black for maximum visibility */
          margin-bottom: 8px;
          line-height: 1.2;
          position: relative;
          z-index: 3;
        }

        .large .card-title {
          font-size: 28px;
        }

        .small .card-title {
          font-size: 18px;
        }

        .card-desc {
          color: #1a1a1a; /* Darker description for visibility */
          font-size: 15px;
          line-height: 1.5;
          margin: 0;
          position: relative;
          z-index: 3;
          font-weight: 500;
        }

        .large .card-desc {
          font-size: 16.5px;
          max-width: 320px;
        }

        .card-bg-effect {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle at center, rgba(255,68,0,0.08) 0%, rgba(255,68,0,0) 80%);
          transform: translate(-50%, -50%) scale(0.5);
          transition: all 0.7s cubic-bezier(0.16, 1, 0.3, 1);
          opacity: 0;
          pointer-events: none;
          z-index: 0;
        }

        .bento-card:hover .card-bg-effect {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1.5);
        }

        @media (max-width: 1024px) {
          .bento-grid {
            grid-auto-rows: auto;
            gap: 20px;
          }
          .bento-card.large, 
          .bento-card.medium, 
          .bento-card.small {
            grid-column: span 12; /* Full width on tablet for better legibility */
            height: auto;
            padding: 32px;
          }
        }

        @media (max-width: 640px) {
          .services-bento-section {
            padding: 80px 20px;
          }
          .bento-card {
            border-radius: 24px;
            padding: 28px;
          }
          .title {
            font-size: 32px;
          }
        }

        /* Responsive adjustment for small screens */
        @media (max-width: 768px) {
          .bento-card.medium {
            grid-column: span 12;
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
            padding: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;
